import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function extractEquipmentsFromXml(carnetId, prefix) {
  const token = await getOrRefreshFirebaseToken();

  const response = await fetch(`${prefix}carnets/${carnetId}/extract-equipments`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return await response.json();
}